import {
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  CardHeader,
  CardTitle,
  Button,
  Label,
} from "reactstrap";
import { NavLink } from "react-router-dom";
import { useMemo, useState, React, useEffect, useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import ReactTable from "components/ReactTable/ReactTable.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingOverlay from "react-loading-overlay";
LoadingOverlay.propTypes = undefined;
import { MainContext } from "context/MainContext.js";

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";

const GroupEdit = () => {
  const history = useHistory();
  const location = useLocation();

  let formError = false;

  const [errorMsg, setErrorMsg] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [selectedSubgroups, setSelectedSubgroups] = useState([]);

  // Object containing all the form values
  const [groupValues, setGroupValues] = useState({
    id: "",
    name: "",
    description: "",
  });

  // Object containing all error messages for every inputs
  const [groupStates, setGroupStates] = useState({
    name: "",
    description: "",
  });

  const [params, setParams] = useState(location.state?.value ?? "");

  const [mode, setMode] = useState(location.state ? location.state.mode : "");
  const privileges = useContext(MainContext);

  useEffect(() => {
    if (
      !Utilities.hasAccess(privileges["devices.groups.create"]) &&
      !Utilities.hasAccess(privileges["devices.groups.edit"])
    ) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }
  }, []);

  const redirectToGroupListPage = () => {
    const location = {
      pathname: "/admin/groups/list",
    };
    history.push(location);
  };

  // Actions to do on submit
  const handleSubmit = (e) => {
    e.preventDefault();

    formError = false;

    // Validate all the field before calling the API
    setGroupStates({
      ...groupStates,
      ["name"]: validateField("name"),
      ["description"]: validateField("description"),
    });

    if (!formError) {
      postData();
    }
  };

  // Validate if field is empty
  const validateField = (field) => {
    let status = "";
    if (groupValues[field] === "") {
      status = "This field is required";
    }

    if (!formError && status.length > 0) {
      formError = true;
    }
    return status;
  };

  useEffect(() => {
    setShowLoading(true);
    const start = Date.now();

    if (mode == "edit" || mode == "view") {
      fetch("/api/v1/group/edit", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          sessionId: sessionStorage.getItem("sessionId"),
          group: params.split("||")[1],
        },
      })
        .then((response) => response.json())
        .then((actualData) => {
          setShowLoading(false);
          if (actualData.status == "200") {
            setGroupValues(actualData.data);
            actualData.data.devices.map((device) => {
              setSelectedDevices((selectedDevices) => [
                ...selectedDevices,
                device.serialNumber,
              ]);
            });
            actualData.data.subgroups.map((group) => {
              setSelectedSubgroups((selectedGroup) => [
                ...selectedGroup,
                group.id,
              ]);
            });
          }
        })
        .catch((err) => {
          console.log(err.message);
          setShowLoading(false);
        });
    } else if (mode == "create") {
      const start = Date.now();

      fetch("/api/v1/group/create", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          sessionId: sessionStorage.getItem("sessionId"),
        },
      })
        .then((response) => response.json())
        .then((actualData) => {
          setShowLoading(false);
        })
        .catch((err) => {
          console.log(err.message);
          setShowLoading(false);
        });
    }
  }, [mode]);

  const postData = () => {
    const start = Date.now();
    setShowLoading(true);

    // Prepare Url and Api Method
    let apiUrl = "";
    let apiMethod = "";
    if (mode == "edit") {
      apiUrl = "/api/v1/group/edit";
      apiMethod = "PUT";
    } else if (mode == "create") {
      apiUrl = "/api/v1/group/create";
      apiMethod = "POST";
    }

    // Call the API
    fetch(apiUrl, {
      method: apiMethod,
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        id: groupValues.id,
        name: groupValues.name,
        description: groupValues.description,
        devices: selectedDevices,
        subgroups: selectedSubgroups,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.error_code) {
          setErrorMsg(actualData.error_code);
          toast.error("A problem occured while saving the group", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          setErrorMsg([]);
          toast.success("Group saved successfully", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });

          // If a group is created successfully, redirect the user to the list page
          if (mode == "create") {
            redirectToGroupListPage();
          }
        }
      })
      .catch((err) => {
        console.log(err.message);
        setShowLoading(false);
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setGroupValues({
      ...groupValues,
      [name]: value,
    });
  };

  const handleDeviceCheckbox = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectedDevices((selectedDevices) => [...selectedDevices, value]);
    } else {
      setSelectedDevices((device) => device.filter((v) => v !== value));
    }
  };

  const handleGroupCheckbox = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectedSubgroups((selectedSubgroups) => [
        ...selectedSubgroups,
        value,
      ]);
    } else {
      setSelectedSubgroups((subgroup) => subgroup.filter((v) => v !== value));
    }
  };

  const deviceColumns = [
    {
      Header: "",
      accessor: "actions",
      sortable: false,
      filterable: false,
      flex: "1 1 0",
      Cell: (props) => {
        return props.row.original.id == groupValues.id || mode == "view" ? (
          ""
        ) : (
          <div style={{ paddingLeft: "7px", paddingBottom: "7px" }}>
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  value={props.row.original.serialNumber}
                  checked={selectedDevices.includes(
                    props.row.original.serialNumber,
                  )}
                  onChange={handleDeviceCheckbox}
                />
                <span className="form-check-sign" />
              </Label>
            </FormGroup>
          </div>
        );
      },
    },
    {
      Header: "System Name",
      accessor: "name",
      sortBy: "name",
      flex: "1 1 0",
    },
    {
      Header: "Serial Number",
      accessor: "serialNumber",
      sortBy: "serialNumber",
      flex: "1 1 0",
    },
    {
      Header: "IP Address",
      accessor: "ipAddress",
      sortBy: "ipAddress",
      flex: "1 1 0",
    },
  ];

  const groupColumns = [
    {
      Header: "",
      accessor: "actions",
      sortable: false,
      filterable: false,
      flex: "1 1 0",
      Cell: (props) => {
        return props.row.original.id == groupValues.id || mode == "view" ? (
          ""
        ) : (
          <div style={{ paddingLeft: "7px", paddingBottom: "7px" }}>
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  value={props.row.original.id}
                  checked={selectedSubgroups.includes(props.row.original.id)}
                  onChange={handleGroupCheckbox}
                />
                <span className="form-check-sign" />
              </Label>
            </FormGroup>
          </div>
        );
      },
    },
    {
      Header: "Group Name",
      accessor: "name",
      sortBy: "name",
      flex: "1 1 0",
    },
    {
      Header: "Group Description",
      accessor: "description",
      sortBy: "description",
      flex: "1 1 0",
    },
  ];

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />

        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </NavLink>
                  </BreadcrumbItem>

                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/groups/list",
                      }}
                    >
                      Groups
                    </NavLink>
                    {params.includes("group") ? (
                      <i>&lt;{params.split("||")[1]}&gt;</i>
                    ) : (
                      ""
                    )}
                  </BreadcrumbItem>

                  <BreadcrumbItem>
                    {mode == "create" ? "Create" : ""}
                    {mode == "edit" ? "Edit" : ""}
                    {mode == "view" ? "View" : ""}
                  </BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Group Information</CardTitle>
              </CardHeader>
              <CardBody>
                {errorMsg.length > 0 ? (
                  <div
                    style={{
                      backgroundColor: "#FFC0A4",
                      border: "1px solid #ef8157",
                      color: "#66615b",
                      paddingTop: "15px",
                      marginBottom: "15px",
                    }}
                  >
                    <ul>
                      {errorMsg.map((d, index) => (
                        <li key={index}>{d}</li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col>
                      <label>Name</label>
                      <FormGroup
                        className={
                          groupStates["name"].length !== 0 ? "has-danger" : ""
                        }
                      >
                        <Input
                          placeholder="Enter name"
                          type="name"
                          name="name"
                          onChange={handleInputChange}
                          value={groupValues.name}
                          readOnly={mode == "view" ? true : false}
                        />
                        <label className="error">{groupStates["name"]}</label>
                      </FormGroup>
                    </Col>
                    <Col>
                      <label>Description</label>
                      <FormGroup
                        className={
                          groupStates["description"].length !== 0
                            ? "has-danger"
                            : ""
                        }
                      >
                        <Input
                          placeholder="Enter description"
                          type="description"
                          name="description"
                          onChange={handleInputChange}
                          value={groupValues.description}
                          readOnly={mode == "view" ? true : false}
                        />
                        <label className="error">
                          {groupStates["description"]}
                        </label>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <h4 className="card-title">GAM</h4>
                    </Col>
                    <Col>
                      <h4 className="card-title">Subgroups</h4>
                    </Col>
                  </Row>
                  {mode != "view" ? (
                    <>
                      <Row>
                        <Col>
                          <ReactTable
                            query="/api/v1/device/list"
                            columns={deviceColumns}
                            title="Devices"
                            className="-striped -highlight primary-pagination"
                            subtable="true"
                          />
                        </Col>
                        <Col>
                          <ReactTable
                            query="/api/v1/group/list"
                            columns={groupColumns}
                            title="Groups"
                            className="-striped -highlight primary-pagination"
                            subtable="true"
                          />
                        </Col>
                      </Row>
                      <Button className="btn-round" color="info" type="submit">
                        Submit
                      </Button>
                    </>
                  ) : (
                    <Row>
                      <Col>
                        <ReactTable
                          query="/api/v1/device/list"
                          columns={deviceColumns}
                          title="Devices"
                          className="-striped -highlight primary-pagination"
                          subtable="true"
                          param={params + "||groupview"}
                          submethodParam={selectedDevices}
                        />
                      </Col>
                      <Col>
                        <ReactTable
                          query="/api/v1/group/subgroups"
                          columns={groupColumns}
                          title="Groups"
                          className="-striped -highlight primary-pagination"
                          subtable="true"
                          param={params + "||groupview"}
                          submethodParam={selectedSubgroups}
                        />
                      </Col>
                    </Row>
                  )}
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default GroupEdit;
